import { environment } from "./../environments/environment";
export class AppEndpoint {
  // static readonly BASE_URL= 'production url';
  static readonly BASE_URL = environment.apiUrl;
  // static readonly BASE_URL= 'https://messagebk.movitext.com';
  // static readonly BASE_URL= 'http://localhost:2021';
  static readonly BASE_URL2 = "";

  /* login */
  public static URL_API_LOGIN: string = AppEndpoint.BASE_URL + "/public/login";
  public static URL_API_LOGOUT: string =
    AppEndpoint.BASE_URL + "/public/auth/logout";
  public static URL_API_FORGOT_PASSWORD: string =
    AppEndpoint.BASE_URL + "/public/auth/forgot-password";
  public static URL_API_RESTORE_PASSWORD: string =
    AppEndpoint.BASE_URL + "/public/auth/restore-password";
  public static URL_API_VALIDATE_OTP: string =
    AppEndpoint.BASE_URL + "/public/auth/validate-otp";
  public static URL_API_REPORT: string =
    AppEndpoint.BASE_URL2 + "/MovitextAPI/detail_report";
  public static UrlDetailReport: string =
    AppEndpoint.BASE_URL + "/private/detail-report";

  public static UrlApiRole: string = AppEndpoint.BASE_URL + "/private/roles";

  /* customer */
  public static UrlApiCustomer: string =
    AppEndpoint.BASE_URL + "/private/company";
  public static UrlApiLogo: string = AppEndpoint.BASE_URL + "/private/logo";
  public static UrlApiValidateCustomer: string =
    AppEndpoint.BASE_URL + "/private/validate-company";
  public static UrlApiCustomers: string =
    AppEndpoint.BASE_URL + "/private/companies";

  public static UrlApiCountries: string =
    AppEndpoint.BASE_URL + "/private/countries";
  public static UrlApiCountriesAvailable: string =
    AppEndpoint.BASE_URL + "/private/countries-available";

  public static UrlApiPlan: string = AppEndpoint.BASE_URL + "/private/plan";
  public static UrlApiPlans: string = AppEndpoint.BASE_URL + "/private/plans";

  public static UrlApiThemeConfig: string =
    AppEndpoint.BASE_URL + "/private/theme-config";
  public static UrlApiThemeConfigs: string =
    AppEndpoint.BASE_URL + "/private/theme-configs";
  public static UrlApiPublicThemeConfigs: string =
    AppEndpoint.BASE_URL + "/public/themes";

  public static UrlApiChat: string = AppEndpoint.BASE_URL + "/private/chat";
  public static UrlApiChats: string = AppEndpoint.BASE_URL + "/private/chats";
  public static UrlApiChatSend: string = AppEndpoint.BASE_URL + "/private/chat";

  public static UrlApiInbox: string = AppEndpoint.BASE_URL + "/private/inbox";
  public static UrlApiInboxs: string = AppEndpoint.BASE_URL + "/private/inboxs";
  public static UrlApiSuperInboxs: string =
    AppEndpoint.BASE_URL + "/private/superInboxs";

  public static UrlApiSender: string = AppEndpoint.BASE_URL + "/private/senders";
  public static UrlApiSenderWithoutCompany: string =
    AppEndpoint.BASE_URL + "/private/sender-withoutcompany";
  public static UrlApiCompanySender: string =
    AppEndpoint.BASE_URL + "/private/company-sender";
  public static UrlApiSenders: string =
    AppEndpoint.BASE_URL + "/private/sender";

  public static UrlApiCustomerSender: string =
    AppEndpoint.BASE_URL + "/private/sender-company";
  public static UrlApiCustomerSenderS: string =
    AppEndpoint.BASE_URL + "/private/senders-company";

  public static UrlApiSubscription: string =
    AppEndpoint.BASE_URL + "/private/subscription";
  public static UrlApiSubscriptions: string =
    AppEndpoint.BASE_URL + "/private/subscriptions";

  public static UrlApiUser: string = AppEndpoint.BASE_URL + "/private/user";
  public static UrlApiUsers: string = AppEndpoint.BASE_URL + "/private/users";

  public static UrlApiBlackList: string =
    AppEndpoint.BASE_URL + "/private/black-list";

  public static UrlReportSend: string =
    AppEndpoint.BASE_URL + "/private/sent-report";
  public static UrlSendDetail: string =
    AppEndpoint.BASE_URL + "/private/send-detail";
  public static UrlSendDetailUserDate: string =
    AppEndpoint.BASE_URL + "/private/send-detail-user-date";
  public static UrlSendSmsReport: string =
    AppEndpoint.BASE_URL + "/private/send-report";
  public static UrlScheduledFilesReport: string =
    AppEndpoint.BASE_URL + "/private/scheduled-files-report";
  public static UrlSendRecipientReport: string =
    AppEndpoint.BASE_URL + "/private/send-by-recipient";
  public static UrlDownloadScheduledFilesReport: string =
    AppEndpoint.BASE_URL + "/private/download-schedule-file";

  public static UrlApiPermission: string =
    AppEndpoint.BASE_URL + "/private/permission";
  public static UrlApiPermissionUpdateUser: string =
    AppEndpoint.BASE_URL + "/private/permission-update-user";
  public static UrlApiPermissions: string =
    AppEndpoint.BASE_URL + "/private/permissions";
  public static UrlApiPermissionExists: string =
    AppEndpoint.BASE_URL + "/private/permission-exists";
  public static UrlApiSuperPermissions: string =
    AppEndpoint.BASE_URL + "/private/superPermissions";

  public static UrlDownloadReportSend: string =
    AppEndpoint.BASE_URL + "/private/download-billing-report";

  public static UrlApiSend: string = AppEndpoint.BASE_URL + "/private/send";

  public static file: string = AppEndpoint.BASE_URL + "/private/file";
  public static fileSend: string = AppEndpoint.BASE_URL + "/private/file-send";
  public static imageSend: string = AppEndpoint.BASE_URL + "/private/logo";
  public static loadingImage: string =
    AppEndpoint.BASE_URL + "/private/loading";
  public static fileCancel: string =
    AppEndpoint.BASE_URL + "/private/file-cancel";
  public static cancelScheduled: string =
    AppEndpoint.BASE_URL + "/private/cancel-scheduled";
  public static scheduledFilesList: string =
    AppEndpoint.BASE_URL + "/private/scheduled-files-list";
  public static bulkSmsDetails: string =
    AppEndpoint.BASE_URL + "/private/bulk-sms-details";

  public static UrlApiDailySendDashboard: string =
    AppEndpoint.BASE_URL + "/private/daily-send";
  public static UrlApiSuperDailySendDashboard: string =
    AppEndpoint.BASE_URL + "/private/super-daily-send";
  public static UrlApiYearSendDashboard: string =
    AppEndpoint.BASE_URL + "/private/month-send";
  public static UrlApiSuperYearSendDashboard: string =
    AppEndpoint.BASE_URL + "/private/super-month-send";
  public static UrlApiYearSendPerCompanyDashboard: string =
    AppEndpoint.BASE_URL + "/private/month-send-per-company";
  public static UrlApiSendTypeDashboard: string =
    AppEndpoint.BASE_URL + "/private/send-type";
  public static UrlApiGetScheduledFile: string =
    AppEndpoint.BASE_URL + "/private/scheduled-files";
  public static UrlApiGetSendInOutPlan: string =
    AppEndpoint.BASE_URL + "/private/send-in-out-plan";
  public static UrlApiGetCompanyByMonth: string =
    AppEndpoint.BASE_URL + "/private/company-by-month";

  public static UrlApiRoute: string = AppEndpoint.BASE_URL + "/private/route";
  public static UrlApiRoutes: string = AppEndpoint.BASE_URL + "/private/routes";

  public static UrlApiBlackout: string =
    AppEndpoint.BASE_URL + "/private/blackout";
  public static UrlApiBlackouts: string =
    AppEndpoint.BASE_URL + "/private/blackouts";

  public static UrlApiPhonebook: string =
    AppEndpoint.BASE_URL + "/private/phonebook";
  public static UrlApiPhonebooks: string =
    AppEndpoint.BASE_URL + "/private/phonebooks";

  public static UrlApiContactGroup: string =
    AppEndpoint.BASE_URL + "/private/contact-group";
  public static UrlApiContactsGroup: string =
    AppEndpoint.BASE_URL + "/private/contacts-group";

  public static UrlApiContact: string =
    AppEndpoint.BASE_URL + "/private/contact";
  public static UrlApiContacts: string =
    AppEndpoint.BASE_URL + "/private/contacts";

  public static UrlApiDailyLogData: string =
    AppEndpoint.BASE_URL + "/private/daily-log-data";

  public static UrlApiInvoice: string =
    AppEndpoint.BASE_URL + "/private/invoice";
}
